import { render, staticRenderFns } from "./inbraakonderzoekHome.vue?vue&type=template&id=75c5c040"
import script from "./inbraakonderzoekHome.vue?vue&type=script&lang=js"
export * from "./inbraakonderzoekHome.vue?vue&type=script&lang=js"
import style0 from "./inbraakonderzoekHome.vue?vue&type=style&index=0&id=75c5c040&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports